import Component from '@Component';
import { eventThrottle } from '@Utility';

const DEFAULTS = {
  stickyClass: 'sticky-scroll-active',
};

export default class SpecificationsTable extends Component {
  static selector = '[data-comp-specifications-table]'

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    Object.assign(this.$options, DEFAULTS, options);

    this.$container.addEventListener('scroll', eventThrottle(
      () => this.stickyClassHandler(), 50,
    ));
  }

  stickyClassHandler() {
    if (this.$container.scrollLeft > 25) {
      this.$container.classList.add(this.$options.stickyClass);
    } else {
      this.$container.classList.remove(this.$options.stickyClass);
    }
  }
}
